<template>
  <div class="flex h-screen overflow-hidden bg-gray-100">
    <!-- Off-canvas menu for mobile -->
    <div v-show="sidebarOpen"
      class="md:hidden">
      <div @click="sidebarOpen = false"
        v-show="sidebarOpen"
        x-transition:enter-start="opacity-0"
        x-transition:enter-end="opacity-100"
        x-transition:leave-start="opacity-100"
        x-transition:leave-end="opacity-0"
        class="fixed inset-0 z-30 transition-opacity duration-300 ease-linear">
        <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
      </div>
      <div class="fixed inset-0 z-40 flex">
        <div v-show="sidebarOpen"
          x-transition:enter-start="-translate-x-full"
          x-transition:enter-end="translate-x-0"
          x-transition:leave-start="translate-x-0"
          x-transition:leave-end="-translate-x-full"
          class="flex flex-col flex-1 w-full max-w-xs pt-5 pb-4 duration-300 ease-in-out transform bg-white">
          <div class="absolute top-0 right-0 p-1 -mr-14">
            <button v-show="sidebarOpen"
              @click="sidebarOpen = false"
              class="flex items-center justify-center w-12 h-12 rounded-full focus:outline-none focus:bg-gray-600">
              <svg class="w-6 h-6 text-white"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="flex items-center flex-shrink-0 px-4"></div>
          <div class="flex-1 h-0 mt-5 overflow-y-auto">
            <nav class="flex-1 px-2 bg-white">
              <router-link :to="{ name: 'sms.sender' }"
                href="#"
                class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                <svg
                  class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                SMS แจ้งเตือน
              </router-link>

              <a href="#"
                class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                <svg
                  class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                ด้านความเสี่ยงสุขภาพ
              </a>

              <!-- <router-link to="/admin/dashboard/risk/topic">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  ความเสี่ยงในแต่ละด้าน
                </a>
              </router-link> -->

              <router-link to="/admin/dashboard/risk/overview">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  ภาพรวมปัจจัยเสี่ยงของแบบประเมิน
                </a>
              </router-link>

              <router-link to="/admin/dashboard/risk">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  แบ่งตามกลุ่ม
                </a>
              </router-link>

              <div href="#"
                class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                <svg
                  class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                ด้านคุณภาพชีวิต
              </div>

              <router-link to="/admin/dashboard/whoqol/overview">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  ภาพรวมด้านคุณภาพชีวิต
                </a>
              </router-link>
              <router-link to="/admin/dashboard/whoqol/aspect">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  แบ่งตามองค์ประกอบต่างๆ
                </a>
              </router-link>
              <router-link to="/admin/dashboard/whoqol/group">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  แบ่งตามกลุ่ม
                </a>
              </router-link>

              <div href="#"
                class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                <svg
                  class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                ด้านพฤติกรรมสร้างเสริมสุขภาพ
              </div>
              <router-link to="/admin/dashboard/hplp/overview">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  ภาพรวมด้านพฤติกรรมสร้างเสริมสุขภาพ
                </a>
              </router-link>
              <router-link to="/admin/dashboard/hplp/aspect">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  แบ่งตามองค์ประกอบต่างๆ
                </a>
              </router-link>
              <router-link to="/admin/dashboard/hplp/group">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  แบ่งตามกลุ่ม
                </a>
              </router-link>
              <div href="#"
                class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                <svg
                  class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                การจัดการผู้ใช้งาน
              </div>
              <router-link :to="{ name: 'FacultyList' }">
                <a href="#"
                  class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                  จัดการผู้ดูข้อมูลภาพรวม
                </a>
              </router-link>
            </nav>
          </div>
        </div>
        <div class="flex-shrink-0 w-14">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64 pt-5 pb-4 bg-white border-r border-gray-200">
        <div class="flex items-center flex-shrink-0 px-4">
          <h2 class="text-2xl font-medium">CMU i-Health</h2>
        </div>
        <div class="flex flex-col flex-1 h-0 mt-5 overflow-y-auto">
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <nav class="flex-1 px-2 bg-white">
            <router-link :to="{ name: 'sms.sender' }"
              href="#"
              class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
              <svg
                class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              SMS แจ้งเตือน
            </router-link>

            <router-link :to="{ name: 'admin-health-recommendation-index' }"
              href="#"
              class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
              <svg
                class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              ส่งคำแนะนำสุขภาพ
            </router-link>

            <a href="#"
              class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
              <svg
                class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              ด้านความเสี่ยงสุขภาพ
            </a>



            <router-link to="/admin/dashboard/risk/overview">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                ภาพรวมปัจจัยเสี่ยงของแบบประเมิน
              </a>
            </router-link>

            <router-link to="/admin/dashboard/risk/topic">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                แบ่งตามหัวข้อ
              </a>
            </router-link>

            <router-link to="/admin/dashboard/risk">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                แบ่งตามกลุ่ม
              </a>
            </router-link>

            <router-link :to="{ name: 'RiskDashboardFaculty' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                ดูรายหน่วยงาน
              </a>
            </router-link>

            <router-link :to="{ name: 'RiskDashboardEmployee' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                รายงานบุคลากรแบ่งตามความเสี่ยง
              </a>
            </router-link>

            <div href="#"
              class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
              <svg
                class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              ด้านคุณภาพชีวิต
            </div>

            <router-link :to="{ name: 'WhoqolDashboardOverview' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                ภาพรวมด้านคุณภาพชีวิต
              </a>
            </router-link>
            <router-link :to="{ name: 'WhoqolDashboardCategory' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                แบ่งตามองค์ประกอบต่างๆ
              </a>
            </router-link>
            <router-link :to="{ name: 'WhoqolDashboardGroup' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                แบ่งตามกลุ่ม
              </a>
            </router-link>

            <router-link :to="{ name: 'WhoqolDashboardFaculty' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                ดูรายหน่วยงาน
              </a>
            </router-link>

            <div href="#"
              class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
              <svg
                class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              ด้านพฤติกรรมสร้างเสริมสุขภาพ
            </div>
            <router-link :to="{ name: 'HPLPDashboardOverview' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                ภาพรวมด้านพฤติกรรมสร้างเสริมสุขภาพ
              </a>
            </router-link>
            <router-link :to="{ name: 'HPLPDashboardCategory' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                แบ่งตามองค์ประกอบต่างๆ
              </a>
            </router-link>
            <router-link :to="{ name: 'HPLPDashboardGroup' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                แบ่งตามกลุ่ม
              </a>
            </router-link>
            <router-link :to="{ name: 'HPLPDashboardFaculty' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                ดูรายหน่วยงาน
              </a>
            </router-link>

            <router-link :to="{ name: 'AdminAssessmentCompare' }">
              <div href="#"
                class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                <svg
                  class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                เปรียบเทียบผลการประเมิน
              </div>
            </router-link>

            <div v-if="
              $store.state.user.roles.map((role) => role.name).includes('super_admin')
            "
              :to="{ name: 'AdminManagement' }"
              href="#"
              class="flex items-center px-2 py-2 mt-1 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
              <svg
                class="w-6 h-6 mr-3 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-500"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              การจัดการผู้ใช้งาน
            </div>

            <router-link v-if="
              $store.state.user.roles.map((role) => role.name).includes('super_admin')
            "
              :to="{ name: 'AdminManagement' }">
              <a href="#"
                class="flex items-center px-2 py-2 mt-1 ml-10 text-sm font-light leading-5 text-gray-500 transition duration-150 ease-in-out rounded-md group hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100">
                จัดการผู้ดูข้อมูลภาพรวม
              </a>
            </router-link>
          </nav>
        </div>
      </div>
    </div>

    <div class="flex flex-col flex-1 w-0 overflow-hidden">
      <div class="relative z-10 flex flex-shrink-0 h-16 bg-white shadow">
        <button @click.stop="sidebarOpen = true"
          class="px-4 text-gray-500 border-r border-gray-200 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden">
          <svg class="w-6 h-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24">
            <path stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h7" />
          </svg>
        </button>
        <div class="flex items-center justify-end w-full px-6">
          <div class="flex items-center flex-start">
            <p class="w-48 mr-4">ประเภทผู้ใช้งาน</p>

            <a-radio-group button-style="solid"
              @change="onEmployeeTypeChanged"
              v-model="dashboardEmployeeType">
              <a-radio-button value="employee"> บุคลากร </a-radio-button>
              <a-radio-button value="student"> นักศึกษา </a-radio-button>
            </a-radio-group>
          </div>

          <div class="flex items-center flex-start">
            <p class="w-32 mr-4">เรียกดูข้อมูลปี</p>

            <a-radio-group button-style="solid"
              @change="onYearChanged"
              v-model="dashboardYear">
              <a-radio-button value="all"> ทั้งหมด </a-radio-button>
              <a-radio-button value="2020"> 2020 </a-radio-button>
              <a-radio-button value="2021"> 2021 </a-radio-button>
              <a-radio-button value="2022"> 2022 </a-radio-button>
              <a-radio-button value="2023"> 2023 </a-radio-button>
            </a-radio-group>
          </div>
        </div>
      </div>
      <main class="relative z-0 flex-1 py-6 overflow-y-auto focus:outline-none"
        tabindex="0"
        x-data
        x-init="$el.focus()">
        <div class="max-w-screen-lg px-4 py-8 mx-auto sm:px-6 md:px-2">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  async beforeRouteEnter(to, from, next) {
    next();
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/profile`,
        headers: {
          authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
        },
      });

      next();
    } catch (error) {
      next({ name: "home", query: { from: "admin" } });
    }
  },
  async created() {
    const response = await axios({
      method: "GET",
      url: `${process.env.VUE_APP_API_URL}/me/profile`,
      headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
    });

    const user = response.data;

    this.$store.dispatch("updateUser", user);

    if (localStorage.getItem("ACCPET_COOKIE")) {
      this.cookieModal = false;
    } else {
      this.cookieModal = true;
    }
  },
  data() {
    return {
      sidebarOpen: false,
      dashboardYear: this.$store.state.dashboardYear,
      dashboardEmployeeType: this.$store.state.dashboardEmployeeType,
    };
  },
  methods: {
    onYearChanged(event) {
      const year = event.target.value;

      this.$store.dispatch("updateDashboardYear", year);
    },

    onEmployeeTypeChanged(event) {
      const employeeType = event.target.value;

      this.$store.dispatch("updateDashboardEmployeeType", employeeType);
    },
  },
};
</script>

<style scoped></style>
